import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Grid,
} from "@material-ui/core";

import { SIREN_CONFIG, SIREN_COLOR } from "config.js";
import { red } from '@material-ui/core/colors';

import { useSelector } from 'react-redux';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { FormattedMessage, useIntl } from "react-intl";
import { ImageView } from "./components"


/**
 * 일자별 헬스데이터 조회
 * 	선택된 일자의 모든 환자 헬스데이터를 다룬다.
 * @param {*} props 
 * @returns 
 */
const SensorHeatMap = (props) => {

  const { className, users, queryParams, ...rest } = props;
  const classes = useStyles();
  const { formatMessage } = useIntl();


  const [roomList, setRoomList] = useState([]);
  const [roomNameList, setRoomNameList] = useState([]);
  const facility_id = useSelector((store) => store.user.facility_id);
  const facility_name = useSelector((store) => store.user.facility_name);



  /**
   * 룸 정보를 얻는다
   */
  const loadRoomList = () => {

    var roomlist = [];

    var url = `${SIREN_CONFIG.HOSTNAME}/room/roomlistWithPatient?facility_id=${facility_id}`;

    const opt = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    fetch(url, opt)
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        responseData.resultData.map(function (row) {
          roomlist.push(
            { roomId: row['roomId'], roomName: row['roomName'], patientName: row['patientName'] }
          );
        });
      })
      .then(() => {
        setRoomList(roomlist);
      });
  }


  /**
 * 해당 시설의 모든 룸 센서리스트를 가져오기
 * for 일반관리자
 * @returns 
 */
  const loadRoomListWithSensor = async () => {

    //이미 로딩했으면, pass함
    if (roomList.length > 0) {
      return roomList;
    }

    var url = `${SIREN_CONFIG.HOSTNAME}/room/roomListWithSensor?facility_id=${facility_id}`;
    const opt = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    let rooms = {};
    let devicelist = [];
    let prev_roomid = '';

    let roomNames = [];

    fetch(url, opt)
      .then(res => res.json())
      .then(responseData => {

        responseData.resultData.map(function (row) {
          var roomId = row['roomId'];
          var roomName = row['roomName'];

          if (prev_roomid === '' || prev_roomid !== roomId) {
            //새로운 room 정보
            devicelist = [];
            rooms[roomId] = devicelist;

            roomNames.push({ roomId: roomId, roomName: roomName });
          } else {
            devicelist = rooms[roomId];
          }

          devicelist.push({
            facility_id: facility_id,
            facility_name: facility_name,
            roomId: roomId,
            roomName: roomName,
            deviceId: row['deviceId'],
            installed_pos_detail: row['installed_pos_detail'],
            keepOnFall: row['keepOnFall'],
            status: '',
          });

          prev_roomid = roomId;
        });

        // console.log("rooms: ", rooms);
        setRoomList(rooms);
        setRoomNameList(roomNames);
      });
  }


  useEffect(() => {
    if (roomList.length === 0) {
      loadRoomList();
    }

    //일반 시설 관리자
    loadRoomListWithSensor();
  }, []);



  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        {roomNameList.map((data) => (
          <Grid item xl={12} lg={12} md={12} xs={12} key={data.roomId}>
            <ImageView roomId={data.roomId} roomName={data.roomName} dataList={roomList[data.roomId]} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};


export default SensorHeatMap;


const theme = createMuiTheme({
  overrides: {
    MuiInputBase: {
      input: {
        //   background: '#dd7711',
        //   padding: 10,
        fontSize: '18px',
      },
    },
  },
})


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
}));

